import gql from 'graphql-tag';


export const EHRENAMTLICHE_FINDEN_SECTION_FIVE_FRAGMENT = gql`
    fragment ehrenamtlicheFindenBenifits on EhrenamtlicheFindenBenifitsType {
    benifitsTitle
    benifitsText
    benifitsImageOne
    benifitsImageTextOne
    benifitsImageTwo
    benifitsImageTextTwo
    benifitsImageThree
    benifitsImageTextThree
    id
  }
`;